import type { ReactElement } from 'react';
import { Flex, Space } from 'antd';
import { Table } from '@ohpen/enso-ui';

/** The controls every configuration table gets. Renders inside a `<Table>`, which owns their state. */
export const ConfigTableActions = (): ReactElement => (
  <Table.ActionsBar>
    <Flex justify="space-between">
      <Space size="middle">
        <Table.GlobalSearch />
      </Space>
      <Space size="middle">
        <Table.ResetFiltersButton />
      </Space>
    </Flex>
  </Table.ActionsBar>
);
